/* eslint-disable vue/attribute-hyphenation */
<!-- EXTERNAL Photo component -->
<template>
  <md-card id="external" class="md-with-hover" @mouseover.native="mouseOver" @mouseleave.native="mouseLeave">
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="md-layout">
        <div class="card-icon" style="margin-left: 5px; margin-top: -7px; margin-right: 0px">
          <md-icon>remove_red_eye</md-icon>
        </div>
        <div class="md-layout-item">
          <h4 class="title" style="font-weight: 400">{{ SectionName }}</h4>
        </div>
        <div class="md-layout md-layout-item md-alignment-center-right">
          <md-button
            v-show="addnlEXT"
            slot="title"
            class="md-button md-warning md-sm"
            style="margin-top: 15px; margin-right: 10%"
            @click.prevent="toggleImgBox"
          >
            ADD'L IMAGES
          </md-button>
        </div>
      </div>
    </md-card-header>

    <md-card-content>
      <!-- Headings & HR-->
      <div class="md-layout md-alignment-center-center" style="text-align: center">
        <div class="md-layout-item">
          <label for="diagExtOD" style="font-weight: bold">RIGHT</label>
        </div>

        <div class="md-layout-item">
          <label for="diagExtOS" style="font-weight: bold">LEFT</label>
        </div>
      </div>

      <hr style="width: 98%" />

      <!--IMAGE-->
      <div class="md-layout md-alignment-center-center" style="text-align: center">
        <div class="md-layout-item" style="max-width: 600px; padding: 2px">
          <drop class="drop" @drop="handleDrop">
            <img
              v-if="noExtImg"
              :style="imgStyle"
              name="paceholder"
              src="@/assets/img/imageNA.jpg"
              height="100px"
              width="auto"
            />

            <img
              v-else
              :src="imgExt_Url"
              :style="imgStyle"
              name="imgExt"
              alt="External Photo"
              height="350px;"
              width="auto"
              @click="extModal"
            />
          </drop>
        </div>
        <!--<div class="md-layout-item"><md-button>Hello</md-button></div>-->
      </div>

      <hr style="width: 98%" />

      <!-- ROW LISTBOXES -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="margin-left: -15px">
        <findings-search :section="Section" :sectionName="SectionName" :mState="mState" />
        <hr style="margin: 0; padding: 0" />
      </div>
    </md-card-content>

    <hr />

    <!-- MODAL LARGE IMAGE -->
    <modal v-if="winModal" md-dynamic-height>
      <template slot="header">
        <div class="md-layout md-alignment-center-right">
          <div class="md-layout-item"></div>
          <div class="md-layout-item md-alignment-top-right">
            <md-icon class="exit-icon" style="color: red" @click.native="winModal = false">cancel</md-icon>
          </div>
        </div>
      </template>
      <template slot="body">
        <div v-if="ExtModal" class="md-layout" @click="winModal = false">
          <div class="md-layout-item">
            <img :src="imgExt_Url" height="300px;" width="auto" />
          </div>
        </div>
      </template>
    </modal>
  </md-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { Modal } from "@/components"
import { bus } from "@/main"
import FindingsSearch from "@/components/GlobeChek/screening/findings/Top5Findings"
export default {
  name: "PhotoExternal",
  components: {
    "findings-search": FindingsSearch,
    Modal
  },
  props: {},
  data() {
    return {
      Section: "External",
      SectionName: "External Photo",
      replaceImg: null,
      mState: false,
      normal: null,
      normalStyle: "",
      winModal: false,
      ExtModal: false,
      imgStyle: "",
      imgStyleInactive: "filter:grayscale(100%);",
      imgStyleActive: "",
      screeningID: null
    }
  },
  computed: {
    ...mapGetters(["externalPhoto", "imagesPath", "addnlEXT", "getImageExternal"]),

    noExtImg() {
      if (this.getImageExternal == false) {
        return true
      } else {
        return false
      }
    },
    imgExt_Url() {
      if (this.replaceImg) {
        return this.replaceImg
      } else {
        return this.getImageExternal.url
      }
    }
  },
  created: function () {},
  mounted: function () {
    this.imgStyle = this.imgStyleInactive
  },
  methods: {
    toggleImgBox() {
      bus.$emit("toggleImgBox", "EXT")
    },
    mouseOver: function () {
      try {
        this.mState = true
        this.imgStyle = this.imgStyleActive
        this.normalStyle = false
      } catch (error) {
        console.log(error)
      }
    },
    mouseLeave: function () {
      try {
        this.mState = false
        this.imgStyle = this.imgStyleInactive
        this.normalStyle = "disabled"
      } catch (error) {
        console.log(error)
      }
    },
    clearModal() {
      this.winModal = false
      this.ExtModal = false
    },
    extModal: function () {
      this.clearModal()
      this.winModal = true
      this.ExtModal = true
    },
    handleDrop(data) {
      // console.log(`You droppped: ${JSON.stringify(data)}`);
      this.replaceImg = data.url
      this.$store.dispatch("SetImgReplace", { EXT: data.url })
      this.$forceUpdate()
    },
  }
}
</script>

<style lang="scss" scoped>
#external {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.values {
  font-size: 0.7rem;
  padding: 0px;
  margin-top: 10px;
  line-height: 1.4em;
  font-weight: 200;
}

.values2 {
  padding: 0px;
  font-weight: 350;
  font-size: 12pt;
  line-height: 14px;
  align-content: start;
}

.mswitch {
  color: rgba(46, 46, 46, 0.8) !important;
  font-size: 0.8rem;
}

.mswitch-normal {
  color: rgba(0, 98, 211, 0.8) !important;
  font-size: 0.95rem;
}

// Variables
$bg-disabled-color: rgba(0, 0, 0, 0.26);
$bg-enabled-color: rgba(63, 81, 181, 0.5);
$lever-disabled-color: #fff;
$lever-enabled-color: #3f51b5;

// Switch
.switch {
  display: inline-block;
  position: relative;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 24px;

  &__input {
    position: absolute;
    top: 0;
    left: 0;
    width: 36px;
    height: 20px;
    opacity: 0;
    z-index: 0;
  }

  // Unchecked
  &__label {
    display: block;
    padding: 0 0 0 44px;
    cursor: pointer;

    &:before {
      content: "";
      position: absolute;
      top: 5px;
      left: 0;
      width: 36px;
      height: 14px;
      background-color: $bg-disabled-color;
      border-radius: 14px;
      z-index: 1;
      transition: background-color 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &:after {
      content: "";
      position: absolute;
      top: 2px;
      left: 0;
      width: 20px;
      height: 20px;
      background-color: $lever-disabled-color;
      border-radius: 14px;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
      z-index: 2;
      transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
      transition-property: left, background-color;
    }
  }

  // Checked
  &__input:checked + &__label {
    &:before {
      background-color: $bg-enabled-color;
    }

    &:after {
      left: 16px;
      background-color: $lever-enabled-color;
    }
  }
}

.drag,
.drop {
  font-family: sans-serif;
  display: inline-block;
  border-radius: 0px;
  background: #ccc;
  position: relative;
  padding: 0px;
  text-align: center;
  vertical-align: top;
}

.drag {
  color: #fff;
  cursor: move;
  background: #777;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
}

.drop {
  background: #eee;
  border-top: 2px solid #ccc;
  border-left: 2px solid #ccc;
}
.md-layout-item.md-alignment-top-right {
  display: flex;
  justify-content: flex-end;
}

.exit-icon {
  cursor: pointer;
  margin: 0px;
  padding: 0px;
}
</style>
